export const conditionTypes = [
    {label: "Medications", value: "MEDICATIONS"},
    {label: "Preventatives", value: "PREVENTATIVES"},
    {label: "Allergic Reactions", value: "ALLERGY"},
    {label: "Health Issues", value: "CHRONIC_CONDITION"},
];

export const addConditionFormTitles = {
    ALLERGY: "Add Allergic Reaction",
    CHRONIC_CONDITION: "Add Health Issue",
    PREVENTATIVES: "Add Preventative",
    MEDICATIONS: "Add Medication",
};

export const vetConditionTypes = [
    {label: "Allergies", value: "ALLERGY"},
    {label: "Health Issues", value: "CHRONIC_CONDITION"},
    {label: "Medications", value: "MEDICATIONS"},
    {label: "Preventatives", value: "PREVENTATIVES"},
];
